import jsonp from 'fetch-jsonp';

class PaymentTokens {
  generateStripeToken(merchantObj, card) {
    Stripe.setPublishableKey(merchantObj.key);

    return new Promise((resolve, reject) => {
      Stripe.card.createToken({
        number: card.number,
        cvc: card.securityCode,
        exp_month: card.expMonth,
        exp_year: card.expYear,
      }, (status, res) => {
        if (res.error) {
          reject(res.error);
        } else {
          resolve(res.id);
        }
      });
    });
  }

  async generateBraintreeToken(merchantObj, card, customer) {
    let response = await braintree.client.create({
      authorization: merchantObj.key,
    });

    response = await response.request({
      endpoint: 'payment_methods/credit_cards',
      method: 'post',
      data: {
        creditCard: {
          number: card.number,
          expirationDate: `${card.expMonth}/${card.expYear}`,
          cvv: card.securityCode,
          billingAddress: {
            postalCode: customer.postal_code,
          },
        }
      }
    });

    return response;
  }

  generateWorldPayToken(merchantObj, card, customer) {
    let customerName = customer.name,

      expMM = `${card.expMonth}`,
      expYY = `${card.expYear}`,

      worldPayApiUrl = 'https://prod.moderntransact.com/ws',

      sharedPayload = {
        payscriptToken: merchantObj.key,
        ResponseType: 'json',
      },

      createCustomerUrl = `${worldPayApiUrl}/recurring.asmx/ManageCustomer?`,

      createTokenUrl = `${worldPayApiUrl}/cardsafe.asmx/StoreCard?`,

      createCustomerPayload = Object.assign({
        TransType: 'ADD',
        Vendor: 1,
        Company: 'VS',
        CustomerName: customerName,
        FirstName: customer.firstName,
        LastName: customer.lastName,
      }, sharedPayload),

      createTokenPayload = Object.assign({
        TokenMode: 'DEFAULT',
        NameOnCard: customerName,
        CardNum: card.cc_num,
        ExpDate: `${expMM.length > 1 ? expMM : `0${expMM}`}${expYY.slice(2, 4)}`,
        Street: customer.address,
        PostalCode: customer.zip,
      }, sharedPayload);

    createCustomerUrl = this._assignJSONPParams(createCustomerUrl, createCustomerPayload);

    return new Promise(async (resolve, reject) => {
      let response = await jsonp(createCustomerUrl, { jsonpCallback: 'mycallback' });

      response = await response.json();

      if (response.error === 'OK') {

        createTokenPayload.CustomerKey = response.CustomerKey;

        createTokenUrl = this._assignJSONPParams(createTokenUrl, createTokenPayload);

        response = await jsonp(createTokenUrl, { jsonpCallback: 'mycallback' });

        response = await response.json();

        if (response.error === 'OK') {
          resolve(`wpt_${response.CardSafeToken}`);
        } else {
          reject(response.error);
        }

      } else {
        reject(response.error);
      }
    });
  }

  _assignJSONPParams(url, payload) {
    for (let key in payload) {
      url += `${key}=${payload[key]}&`;
    }

    url = url.slice(0, -1);

    return url;
  }
}

export default new PaymentTokens();